export const parsePaginationCursor = (
  url: string | null | undefined
): string | null => new URLSearchParams(url ?? "").get("start_at");

export const parsePaginationCursors = (meta?: {
  next: string | null;
  previous: string | null;
}): { nextCursor: string | null; previousCursor: string | null } => ({
  nextCursor: parsePaginationCursor(meta?.next),
  previousCursor: parsePaginationCursor(meta?.previous),
});
